import heyThereImage from "../assets/images/box_img.png";
import Button from "./Button";

import Text from "./Text";

const HeyThereSection = () => {
  return (
    <div className="xs:p-0 sm:px-6 lg:p-0">
      <div className="bg-[#f6f7f2] flex xs:flex-col md:flex-row p-4 justify-center items-center">
        <div className="img px-4 xs:w-full md:w-5/12 flex justify-center">
          <img src={heyThereImage} alt="" className="xs:mb-0 md:-mb-12" />
        </div>
        <div className="content xs:w-full md:w-6/12 mx-auto p-4 xs:text-center lg:text-left">
          <div className="heading pb-4 text-base">
            <Text
              text={
                "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry"
              }
              component="h6"
              classes={""}
            />
          </div>
          <div className="text pb-4 text-sm text-[#8b8b8b]">
            <Text
              text={
                "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book."
              }
            />
          </div>
          <div className="button flex xs:justify-center lg:justify-start">
            <Button isHovered transition>
              Explore Now
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeyThereSection;
